import CustomerDetailContainer from "./CustomerDetailContainer";
import CustomerDetailStore from "./CustomerDetailStore";
export default CustomerDetailStore(CustomerDetailContainer);